export default __webpack_public_path__ + "static/media/india.90994583.svg";